/* eslint-disable */
import axios from 'axios'
import Vue from 'vue'
import MainService from './MainService'

const axiosConfig = {
  headers: <any>{
    'Content-type': 'application/json',
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_WIDGET_URL}`
  }
}

class TotemServices {
  async getAuth (authentication:any) {
    const config = <any> {
      method: authentication.method,
      url: authentication.route,
      headers: axiosConfig.headers,
      data: authentication.body
    }
    return axios(config)
  }

  saveError (error: any) {
    const detail = {
      url: error?.config?.url,
      method: error?.config?.method?.toUpperCase(),
      payload: error?.config?.data,
      status: error?.response?.status || error?.status,
      code: error?.code,
      message: error?.message,
      time: new Date().toISOString()
    }
    const storageKey = 'totem-status-error'

    let errorsList
    try {
      errorsList = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
    } catch (e) {
      errorsList = []
    }

    errorsList.push(detail)
    sessionStorage.setItem(storageKey, JSON.stringify(errorsList))
  }

  saveSuccess (data: any) {
    const detail = {
      totem: data?.totemId,
      status: data?.status,
      time: new Date().toISOString()
    }

    const storageKey = 'totem-status-success'

    let successList
    try {
      successList = JSON.parse(sessionStorage.getItem(storageKey) || '[]')
    } catch (e) {
      successList = []
    }

    successList.push(detail)
    sessionStorage.setItem(storageKey, JSON.stringify(successList))
  }

  async setTotemStatus (params: Object) {
    return true
    const totemMode = Vue.prototype.$organization.totemMode()
    const dataHttp = totemMode.data.HTTP

    if (!dataHttp) {
      return false
    }

    let authSuccess = true
    if (dataHttp?.authentication) {
      const maxRetries = 5
      authSuccess = false
      for (let attempt = 0; attempt < maxRetries; attempt++) {
        try {
          const response: any = await this.getAuth(dataHttp.authentication)
          const res = response.data
          axiosConfig.headers.Authorization = `${res.token_type} ${res.access_token}`
          authSuccess = true
          break
        } catch (error) {
          const messageError = `getAuth attempt ${attempt + 1} failed: `
          console.log(messageError, error)

          if (attempt === maxRetries - 1) {
            return false
          }
        }
      }
    }

    if (!authSuccess || !totemMode.isActive || !dataHttp.totemStatus || !dataHttp.totemStatus.method) {
      return false
    }

    if (dataHttp.totemStatus.headers) {
      const headerKeys = Object.keys(dataHttp.totemStatus.headers)

      for (let index = 0; index < headerKeys.length; index++) {
        const key = headerKeys[index]
        axiosConfig.headers[key] = dataHttp.totemStatus.headers[key]
      }
    }

    const http = <any> axios.create(axiosConfig)

    const httpData = {
      method: dataHttp.totemStatus.method,
      route: dataHttp.totemStatus.route,
      params: dataHttp.totemStatus.method === 'get' ? { params } : params
    }

    return http[httpData.method](httpData.route, httpData.params)
      .then((response: Object) => {
        this.saveSuccess(params)
        console.log('setTotemStatus', response)
      })
      .catch((error: any) => {
        this.saveError(error)
        console.log('setTotemStatus ERROR', error)
      })
  }

  async setWidgetUuidSession(sessionId:number) {
    const data = {
      route: `ocular/widget/totem/sessions`,
      params: {
        sessionId
      }
    }

    return MainService.post(data)
  }
}

export default new TotemServices()
